import { BlockCategory, registerBlock } from "../../lib/register-block";
import { Wallet2 } from "lucide-react";
import { WalletEditorRenderer } from "./editor";
import { WalletEmailRenderer } from "./email";
import type { WalletBlockProps } from "./types";
import { WalletEmailPanelRenderer } from "./email-panel";
import { WalletWeb } from "./web";
import { WalletWebEditor } from "./web-editor";


export default registerBlock<WalletBlockProps>({
  type: "wallet",
  name: "editorBlocksLibrary.blocks.wallet.title",
  description: "editorBlocksLibrary.blocks.wallet.description",
  Icon: Wallet2,
  category: BlockCategory.TRACKING,
  premium: true,
  components: {
    email: {
      component: WalletEmailRenderer,
      editor: {
        component: WalletEditorRenderer,
      },
      configPanel: {
        features: {
          delete: true,
        },
        component: WalletEmailPanelRenderer,
      },
    },
    web: {
      component: WalletWeb,
      editor: {
        component: WalletWebEditor,
      },
      configPanel: {
        features: {
          delete: true,
        },
        component: WalletEmailPanelRenderer,
      },
    },
  },
});
